<template>
  <div class="request-form-wrapper">
    <loading-spinner v-if="loading" />
    <!-- HTML is loaded via XHR. -->
    <div
      class="request-form"
      :class="{ loading: loading }"
      ref="configRequestQuoteFormWrapper"
      v-html="html"
    ></div>
    <ul v-if="errors" class="errors">
      <li v-for="(messages, key) in errors" :key="key">
        <span v-for="(message, index) in messages" :key="index">
          {{ message }}
        </span>
      </li>
    </ul>
  </div>
</template>

<script>
import axios from "axios";
import LoadingSpinner from "../../../atoms/loading_spinner.js";

export default {
  components: {
    LoadingSpinner,
  },
  props: {
    active: {
      type: Boolean,
      default: false,
    },
    selections: {
      type: Map,
      default: new Map(),
    },
    configurationPricing: {
      type: Array,
      default: [],
    },
  },
  mounted() {
    this.get();
  },
  data() {
    return {
      loading: false,
      html: "",
      errors: null,
    };
  },
  computed: {
    skuStrings() {
      return this.selections.map((value, key) => {
        array.push(
          `<a href="https://lightart.com/config/sku/${this.selections.get(key).sku}#summary" target="_blank">
            ${this.selections.get(key).qty}qty - ${this.selections.get(key).sku}
          </a>`
        );
      });
    },
    showConfiguratorPricing() {
      return window.hasOwnProperty("showConfiguratorPricing")
        ? window.showConfiguratorPricing
        : false;
    },
  },
  methods: {
    get() {
      this.loading = true;

      const config = {
        headers: {
          "X-Requested-With": "XMLHttpRequest",
        },
      };

      axios
        .get("/configurator-module/api/template/form", config)
        .then((response) => {
          this.html = response.data;
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    submit() {
      this.loading = true;
      /**
       * @todo
       *
       * I hate this chunk.
       * We are using DOM-based selection due to dynamic importation of the template.
       * Could probably be re-thought / refactored to be less gross.
       *
       */
      let formElement = this.$refs.configRequestQuoteFormWrapper.firstElementChild;
      let jsValidationField = formElement.querySelector("input[name^='alojs']");

      if (jsValidationField) {
        jsValidationField.value = jsValidationField.id;
      }

      let formData = new FormData(formElement);
      const parsedSelections = Array.from(this.selections, ([key, value]) => ({ qty: value.qty, sku: value.sku, title: value.title }));

      formData.append("fields[pageOrigin]", "Configurator Page");
      formData.append("fields[rawSelections]", JSON.stringify(parsedSelections));

      if (this.showConfiguratorPricing) {
        formData.append("fields[pricingEstimate]", JSON.stringify(this.configurationPricing));
      } else {
        formData.append("fields[pricingEstimate]", "User not authorized to view pricing.");
      }

      axios
        .post("/sprout-forms/entries/save-entry", formData)
        .then((response) => {
          if (response.data.success) {
            this.$emit("successful-submission");
          } else {
            if (response.data.errors) {
              this.errors = response.data.errors;
            }
          }
        })
        .catch((error) => {
          this.failure = true;
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>
